// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"962":"3cc34012","990":"ddedc984"}[chunkId] + ".chunk.css";
};